
  function newClass(){
    setTimeout(function(){
     document.querySelectorAll('.docapp-fg-pin-cropper').forEach(cropper => {
      const img = cropper.querySelector('img');
       console.log("img",img);
      if(img) {
        const newDiv = document.createElement('div');
        newDiv.classList.add('your-new-class');
        cropper.insertBefore(newDiv, img);
      }
    });
      console.log('New div inserted above all images inside .new..');
      },1000);
    console.log('New div inserted above all images inside .docapp-fg-pin-cropper');
}


let swiper;

        function initSwiper() {
        swiper = new Swiper('.cart-drawer-recommendation', {
        // Optional parameters
        spaceBetween:40,
        slidesPerView:'auto',
        loop: false,
        observer: true,
          scrollbar: {
          el: ".swiper-scrollbar",
          hide: false,
          draggable: true
        }
        });
        }

  function freeProduct(){
      var variant_id = $("#cartfreeproduct").val(); 
      if(variant_id !=undefined){
      var total_value = $("#cartfreeproduct").attr('data-cart-limit');
    var TotalVal =0;
          if(total_value != undefined){
       TotalVal = parseFloat(total_value); 
          }
     var ProductKey = $('.cart-item.freeProduct').attr('item-key');

    $.ajax({
            type: 'POST',
            url: '/cart',
            dataType: 'json',
             async : false,
              success: function (data) {               
                  var CartPrice = data.total_price/100;
                  if($('.cart-item.freeProduct').length == 0 && CartPrice >  TotalVal){
                   jQuery.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                     async : false,
                    data: { quantity: 1,id: variant_id,properties: {"_Free-Gift": 'Free-Gift' }},
                    dataType: 'json',
                    success: function (data) { 
                         console.log(data);
                         $.ajax({
                         url: '/cart',
                         type: "GET",
                         dataType: "html",
                             success: function(data) {
                              $("cart-drawer-items").html($(data).find('cart-drawer-items').html());
                              },
                          });
                        } ,       
         })
   }else if($('.cart-item.freeProduct').length != 0 && (CartPrice <  TotalVal || TotalVal == 0) ){
 
     jQuery.ajax({
            type: 'POST',
            url: '/cart/change.js',
             async : false,
            data: { quantity: 0,id: ProductKey},
            dataType: 'json',
              success: function (data) { 
               console.log(data);
               $.ajax({
               url: '/cart',
               type: "GET",
               dataType: "html",
                   success: function(data) {
                   $("#CartDrawer").html($(data).find('#CartDrawer').html());
                 var productLenght = $('tr.cart-item').length;
                     if(productLenght==0){
                       $('cart-drawer.drawer').addClass('is-empty');
                     }         
                     $('.cart-count-bubble').html($(data).find('.cart-count-bubble').html());
                     },
                });
              }        
           })         
         }  
       }
    });
      }
}

freeProduct();
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    setTimeout(function(){

  $.ajax({
  url: "/cart?view=mobile-sticky-free-shipping-bar",
  type: "GET",
  success: function(data) {
   $('.mobile_free_shipping_bar').html(data); 
    newClass();
  },
  error: function(xhr, status, error) {
    console.error("An error occurred: " + status + " " + error);
  }
});
    },500);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
   
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
  setTimeout(function(){
newClass();
  $.ajax({
  url: "/cart?view=mobile-sticky-free-shipping-bar",
  type: "GET",
  success: function(data) {
   $('.mobile_free_shipping_bar').html(data); 
  },
  error: function(xhr, status, error) {
    console.error("An error occurred: " + status + " " + error);
  }
});
    },500);
    
  }

  onCartUpdate() {
  setTimeout(function(){

  $.ajax({
  url: "/cart?view=mobile-sticky-free-shipping-bar",
  type: "GET",
  success: function(data) {
   $('.mobile_free_shipping_bar').html(data); 
    newClass();
  },
  error: function(xhr, status, error) {
    console.error("An error occurred: " + status + " " + error);
  }
});
    },500);
    
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
          
         initSwiper();
         
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
   
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    var quantity1 = quantity;
    this.enableLoading(line);
  var random_no = $(`#CartDrawer-Item-${line}`).attr('item_pro_id');

  
if($('#custom_qtantity').length > 0){
  setTimeout(function(){
     var updatevalue = $('input[name="assortment"]:checked').val();
   $('#quantity_select_box').find('.quantity__input').val(updatevalue);
    newClass();
  },1000)
}
   
    
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {

        freeProduct();

         
        $('#CartDrawer .cart-item').each(function(){
           var pro_id = $(this).attr('item_pro_id');
          if($(this).attr('random_attr') == random_no){
             var id1 = $(this).attr('item-key1');
            jQuery.ajax({
            type: 'POST',
            url: '/cart/change.js',
             async : false,
            data: { quantity: quantity1,id: id1},
            dataType: 'json',
              success: function (data) { 
              $.ajax({
               url: '/cart',
               type: "GET",
               dataType: "html",
                   success: function(data) {
                    $("#CartDrawer").html($(data).find('#CartDrawer').html());
                      var productLenght = $('tr.cart-item').length;
                         if(productLenght == 0){
                       $('cart-drawer.drawer').addClass('is-empty');
                         $('#main-cart-footer').addClass('is-empty');
                      $('cart-items.gradient').addClass('is-empty');
                      }   
                        if(productLenght == 1){
                       $('#main-cart-footer').addClass('is-empty');
                      $('cart-items.gradient').addClass('is-empty');
                      }   
                     
                      $('.cart-count-bubble').html($(data).find('#CartDrawer .cart-item').length);
                     $('.cart-count-bubble').html($(data).find('.cart-count-bubble').html());
                      $('.cart__items').html($(data).find('.cart__items').html());
                      },
                });
              }
           })
           }
       });

        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
        initSwiper();
        
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;
      if(this.lineItemStatusElement != null){
    this.lineItemStatusElement.setAttribute('aria-hidden', true);
      }

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
       if(this.lineItemStatusElement != null){
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
       }
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
